// extracted by mini-css-extract-plugin
export default {"supportDeskBtn":"DefaultLayout_supportDeskBtn_EILFa","icon":"DefaultLayout_icon_vK0fe","spinAround":"DefaultLayout_spinAround_CQt9x"};